function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { globals } from '../utils/window.js';
import { registerMethods } from '../utils/methods.js';
import Animator from './Animator.js';
import EventTarget from '../types/EventTarget.js';
var makeSchedule = function makeSchedule(runnerInfo) {
    var start = runnerInfo.start;
    var duration = runnerInfo.runner.duration();
    var end = start + duration;
    return {
        start: start,
        duration: duration,
        end: end,
        runner: runnerInfo.runner
    };
};
var defaultSource = function defaultSource() {
    var w = globals.window;
    return (w.performance || w.Date).now();
};
var Timeline = /*#__PURE__*/ function(EventTarget) {
    "use strict";
    _inherits(Timeline, EventTarget);
    function Timeline() {
        var timeSource = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultSource;
        _class_call_check(this, Timeline);
        var _this;
        _this = _call_super(this, Timeline);
        _this._timeSource = timeSource;
        // terminate resets all variables to their initial state
        _this.terminate();
        return _this;
    }
    _create_class(Timeline, [
        {
            key: "active",
            value: function active() {
                return !!this._nextFrame;
            }
        },
        {
            key: "finish",
            value: function finish() {
                // Go to end and pause
                this.time(this.getEndTimeOfTimeline() + 1);
                return this.pause();
            }
        },
        {
            // Calculates the end of the timeline
            key: "getEndTime",
            value: function getEndTime() {
                var lastRunnerInfo = this.getLastRunnerInfo();
                var lastDuration = lastRunnerInfo ? lastRunnerInfo.runner.duration() : 0;
                var lastStartTime = lastRunnerInfo ? lastRunnerInfo.start : this._time;
                return lastStartTime + lastDuration;
            }
        },
        {
            key: "getEndTimeOfTimeline",
            value: function getEndTimeOfTimeline() {
                var _Math;
                var endTimes = this._runners.map(function(i) {
                    return i.start + i.runner.duration();
                });
                return (_Math = Math).max.apply(_Math, [
                    0
                ].concat(_to_consumable_array(endTimes)));
            }
        },
        {
            key: "getLastRunnerInfo",
            value: function getLastRunnerInfo() {
                return this.getRunnerInfoById(this._lastRunnerId);
            }
        },
        {
            key: "getRunnerInfoById",
            value: function getRunnerInfoById(id) {
                return this._runners[this._runnerIds.indexOf(id)] || null;
            }
        },
        {
            key: "pause",
            value: function pause() {
                this._paused = true;
                return this._continue();
            }
        },
        {
            key: "persist",
            value: function persist(dtOrForever) {
                if (dtOrForever == null) return this._persist;
                this._persist = dtOrForever;
                return this;
            }
        },
        {
            key: "play",
            value: function play() {
                // Now make sure we are not paused and continue the animation
                this._paused = false;
                return this.updateTime()._continue();
            }
        },
        {
            key: "reverse",
            value: function reverse(yes) {
                var currentSpeed = this.speed();
                if (yes == null) return this.speed(-currentSpeed);
                var positive = Math.abs(currentSpeed);
                return this.speed(yes ? -positive : positive);
            }
        },
        {
            // schedules a runner on the timeline
            key: "schedule",
            value: function schedule(runner, delay, when) {
                if (runner == null) {
                    return this._runners.map(makeSchedule);
                }
                // The start time for the next animation can either be given explicitly,
                // derived from the current timeline time or it can be relative to the
                // last start time to chain animations directly
                var absoluteStartTime = 0;
                var endTime = this.getEndTime();
                delay = delay || 0;
                // Work out when to start the animation
                if (when == null || when === 'last' || when === 'after') {
                    // Take the last time and increment
                    absoluteStartTime = endTime;
                } else if (when === 'absolute' || when === 'start') {
                    absoluteStartTime = delay;
                    delay = 0;
                } else if (when === 'now') {
                    absoluteStartTime = this._time;
                } else if (when === 'relative') {
                    var runnerInfo = this.getRunnerInfoById(runner.id);
                    if (runnerInfo) {
                        absoluteStartTime = runnerInfo.start + delay;
                        delay = 0;
                    }
                } else if (when === 'with-last') {
                    var lastRunnerInfo = this.getLastRunnerInfo();
                    var lastStartTime = lastRunnerInfo ? lastRunnerInfo.start : this._time;
                    absoluteStartTime = lastStartTime;
                } else {
                    throw new Error('Invalid value for the "when" parameter');
                }
                // Manage runner
                runner.unschedule();
                runner.timeline(this);
                var persist = runner.persist();
                var runnerInfo1 = {
                    persist: persist === null ? this._persist : persist,
                    start: absoluteStartTime + delay,
                    runner: runner
                };
                this._lastRunnerId = runner.id;
                this._runners.push(runnerInfo1);
                this._runners.sort(function(a, b) {
                    return a.start - b.start;
                });
                this._runnerIds = this._runners.map(function(info) {
                    return info.runner.id;
                });
                this.updateTime()._continue();
                return this;
            }
        },
        {
            key: "seek",
            value: function seek(dt) {
                return this.time(this._time + dt);
            }
        },
        {
            key: "source",
            value: function source(fn) {
                if (fn == null) return this._timeSource;
                this._timeSource = fn;
                return this;
            }
        },
        {
            key: "speed",
            value: function speed(speed) {
                if (speed == null) return this._speed;
                this._speed = speed;
                return this;
            }
        },
        {
            key: "stop",
            value: function stop() {
                // Go to start and pause
                this.time(0);
                return this.pause();
            }
        },
        {
            key: "time",
            value: function time(time) {
                if (time == null) return this._time;
                this._time = time;
                return this._continue(true);
            }
        },
        {
            // Remove the runner from this timeline
            key: "unschedule",
            value: function unschedule(runner) {
                var index = this._runnerIds.indexOf(runner.id);
                if (index < 0) return this;
                this._runners.splice(index, 1);
                this._runnerIds.splice(index, 1);
                runner.timeline(null);
                return this;
            }
        },
        {
            // Makes sure, that after pausing the time doesn't jump
            key: "updateTime",
            value: function updateTime() {
                if (!this.active()) {
                    this._lastSourceTime = this._timeSource();
                }
                return this;
            }
        },
        {
            // Checks if we are running and continues the animation
            key: "_continue",
            value: function _continue() {
                var immediateStep = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                Animator.cancelFrame(this._nextFrame);
                this._nextFrame = null;
                if (immediateStep) return this._stepImmediate();
                if (this._paused) return this;
                this._nextFrame = Animator.frame(this._step);
                return this;
            }
        },
        {
            key: "_stepFn",
            value: function _stepFn() {
                var immediateStep = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                // Get the time delta from the last time and update the time
                var time = this._timeSource();
                var dtSource = time - this._lastSourceTime;
                if (immediateStep) dtSource = 0;
                var dtTime = this._speed * dtSource + (this._time - this._lastStepTime);
                this._lastSourceTime = time;
                // Only update the time if we use the timeSource.
                // Otherwise use the current time
                if (!immediateStep) {
                    // Update the time
                    this._time += dtTime;
                    this._time = this._time < 0 ? 0 : this._time;
                }
                this._lastStepTime = this._time;
                this.fire('time', this._time);
                // This is for the case that the timeline was seeked so that the time
                // is now before the startTime of the runner. That is why we need to set
                // the runner to position 0
                // FIXME:
                // However, resetting in insertion order leads to bugs. Considering the case,
                // where 2 runners change the same attribute but in different times,
                // resetting both of them will lead to the case where the later defined
                // runner always wins the reset even if the other runner started earlier
                // and therefore should win the attribute battle
                // this can be solved by resetting them backwards
                for(var k = this._runners.length; k--;){
                    // Get and run the current runner and ignore it if its inactive
                    var runnerInfo = this._runners[k];
                    var runner = runnerInfo.runner;
                    // Make sure that we give the actual difference
                    // between runner start time and now
                    var dtToStart = this._time - runnerInfo.start;
                    // Dont run runner if not started yet
                    // and try to reset it
                    if (dtToStart <= 0) {
                        runner.reset();
                    }
                }
                // Run all of the runners directly
                var runnersLeft = false;
                for(var i = 0, len = this._runners.length; i < len; i++){
                    // Get and run the current runner and ignore it if its inactive
                    var runnerInfo1 = this._runners[i];
                    var runner1 = runnerInfo1.runner;
                    var dt = dtTime;
                    // Make sure that we give the actual difference
                    // between runner start time and now
                    var dtToStart1 = this._time - runnerInfo1.start;
                    // Dont run runner if not started yet
                    if (dtToStart1 <= 0) {
                        runnersLeft = true;
                        continue;
                    } else if (dtToStart1 < dt) {
                        // Adjust dt to make sure that animation is on point
                        dt = dtToStart1;
                    }
                    if (!runner1.active()) continue;
                    // If this runner is still going, signal that we need another animation
                    // frame, otherwise, remove the completed runner
                    var finished = runner1.step(dt).done;
                    if (!finished) {
                        runnersLeft = true;
                    // continue
                    } else if (runnerInfo1.persist !== true) {
                        // runner is finished. And runner might get removed
                        var endTime = runner1.duration() - runner1.time() + this._time;
                        if (endTime + runnerInfo1.persist < this._time) {
                            // Delete runner and correct index
                            runner1.unschedule();
                            --i;
                            --len;
                        }
                    }
                }
                // Basically: we continue when there are runners right from us in time
                // when -->, and when runners are left from us when <--
                if (runnersLeft && !(this._speed < 0 && this._time === 0) || this._runnerIds.length && this._speed < 0 && this._time > 0) {
                    this._continue();
                } else {
                    this.pause();
                    this.fire('finished');
                }
                return this;
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                // cleanup memory
                // Store the timing variables
                this._startTime = 0;
                this._speed = 1.0;
                // Determines how long a runner is hold in memory. Can be a dt or true/false
                this._persist = 0;
                // Keep track of the running animations and their starting parameters
                this._nextFrame = null;
                this._paused = true;
                this._runners = [];
                this._runnerIds = [];
                this._lastRunnerId = -1;
                this._time = 0;
                this._lastSourceTime = 0;
                this._lastStepTime = 0;
                // Make sure that step is always called in class context
                this._step = this._stepFn.bind(this, false);
                this._stepImmediate = this._stepFn.bind(this, true);
            }
        }
    ]);
    return Timeline;
}(_wrap_native_super(EventTarget));
export { Timeline as default };
registerMethods({
    Element: {
        timeline: function timeline(timeline) {
            if (timeline == null) {
                this._timeline = this._timeline || new Timeline();
                return this._timeline;
            } else {
                this._timeline = timeline;
                return this;
            }
        }
    }
});
